export default "__VITE_ASSET__C54EwtmI__"